import React from 'react';
import {
  FormControlLabel,
  Switch,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { includes } from 'lodash';

import Icon from '../../../../../../icon';

const ToggleCopyUser = ({
  userKey,
  userLabel,
  users,
  onChange,
  classes,
}) => (
  <div className={classes.row}>
    <FormControlLabel
      control={(
        <Switch
          checked={includes(users, userKey)}
          onChange={onChange}
          color="primary"
        />
      )}
      label={(
        <div className={classes.labelContainer}>
          <Icon
            className={classes.icon}
            value="plumpy plumpy-xXjlE05o3dcg"
          />
          <span>{userLabel}</span>
        </div>
      )}
    />
  </div>
);

ToggleCopyUser.propTypes = {
  userKey: PropTypes.number.isRequired,
  userLabel: PropTypes.string.isRequired,
  users: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
};

const styles = (theme) => ({
  row: {
    contentVisibility: 'auto',
    containIntrinsicSize: `auto ${theme.spacing(5)}px`,
  },
  labelContainer: {
    display: 'flex',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
});

export default withStyles(styles)(ToggleCopyUser);
